module.exports = __webpack_public_path__ + "static/img/on-3p.c7e7ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/on-3p.png
// module id = xG82
// module chunks = 1